import {UserRole} from './user-role.model';
import {UserRoute} from './user-route.model';
import {UserFeature} from './user-feature.model';

export class Permission {
  roles: UserRole[];
  routes: UserRoute[];
  features: UserFeature[];
}
